<template>
  <div class="Com_12">
    <title1 type="2" title="各时段发电效率"> </title1>
    <div class="Com_12_bottom" style="width: 565px; height: 364px">
      <MyEcharts v-if="showcdata" :id="'Com_12123123'" :options="cdata" />
    </div>
  </div>
</template>
    
    <script>
import title1 from "@/views/exposition/components/title3";
import { dataInterface } from "@/api/dataInterfaceApi";
import MyEcharts from "@/views/exposition/components/charts/echarts.vue";
import * as echarts from "echarts5";
export default {
  components: {
    title1,
    MyEcharts
  },
  data() {
    return {
      showcdata: false,
      cdata: {
        tooltip: {
          trigger: "axis",
		  textStyle: {
		    fontSize: 50  // 设置字体大小为16px
		  }
        },
		grid: {
		  top: "23%",
		  fontSize: 19
		},
        legend: {
          itemWidth: 12,
          itemHeight: 8,
          data: ["尖", "峰", "平", "谷"],
        },
        xAxis: {
          data: [],
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          name: "单位: %  ",
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "发电效率",
            type: "bar",
            barWidth: 13,
            stack: "使用情况",
            data: [705, 720, 736, 710, 710, 720, 730],
			tooltip: {
			  valueFormatter: function (value) {
			    return value + " %";
			  },
			},
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#82F2F4",
                  },
                  {
                    offset: 1,
                    color: "#2E4039",
                  },
                ]),
              },
            },
          }
        ],
      },
    };
  },
  mounted() {
    this.$bus.$on("onfangdiangonglv", () => {
      this.getBattery24hours();
    });
    this.getBattery24hours();
  },
  destroyed() {
    // this.$bus.$off('onfangdiangonglv')
  },
  methods: {
    //获取24小时电次数分布
    getBattery24hours() {
      let params = {
        "enCode": "zngf-dz-geshiduan-fadianxiaolv",// 接口code
            "@station_id": localStorage.getItem('guangfuStationId') ? localStorage.getItem('guangfuStationId') : "320500H001" // 接口传参
      };
      this.showcdata = false;
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          console.log(res, "各时段发电效率");
          if (res) {
            let data = [];
            let xAxis = [];
            res.forEach((item) => {
              xAxis.push(item.cur_date);
              data.push(item.fdxl);
            });
            this.cdata.xAxis.data = xAxis;
            this.cdata.series[0].data = data;
            this.showcdata = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
    
  <style lang="scss" scoped>
.Com_12 {
  .Com_12_bottom {
    // background: red;
  }
}
</style>